export default {
  translation: {
    /*Header*/
    home: "Inicio",
    contact: "Contacto",
    store: "Tienda",

    /*Event List*/
    home2: "CASA",
    sidebar: "SIN BARRA LATERAL",
    title: "EL TORNEO ANUAL DE APEX LEGENDS ESTÁ AQUÍ",
    date: "4 de marzo de 2020",
    description:
      "Lorem Ipsum es simplemente texto de relleno de la industria de la impresión y " +
      "la composición tipográfica. Lorem Ipsum ha sido el texto de relleno estándar de la industria" +
      " desde el siglo XVI, cuando un impresor desconocido tomó una galera de tipos y la mezcló para" +
      " hacer un libro de muestras tipográfico. Ha sobrevivido no solo a cinco siglos, sino también al " +
      "salto a la composición tipográfica electrónica, permaneciendo esencialmente sin cambios.",
    more: "Más detalles",

    /*Event Details*/
    /*event specifics*/
    prizePool: "PREMIO",
    playModel: "MODELO",
    platform: "PLATAFORMA",
    player: "JUGADOR/A",
    gameDay: "25 de Agosto de 2020",
    gamePlayers: "4 GRUPOS",
    /*tournament*/
    about: "SOBRE EL TORNEO",

    /* Tournament Bracket */
    tournamentRound: {
      round1: "La ronda 1",
      round2: "La ronda 2",
      round3: "La ronda 3",
      semi: "semifinales oeste",
      east: "semifinales este",
      final: "Campeonato",
    },

    /*tournament details*/
    tournamentDetails: {
      meeting: "Conocer a los Jugadores",
    },

    /*Contact*/
    contactHeader: "Escriba una línea si está interesado en unirse",
    contactSubHeader: "Ponerse en contacto",
    placeholder: {
      firstName: "Nombre de Pila",
      lastName: "Apellido",
      email: "Correo electrónico",
      message: "Tu mensaje",
    },
    sendButton: "ENVIAR",

    /*Store*/
    storeItemPrice: "$50.00",
    itemNames: {
      fifa: "FIFA",
      cod: "CALL OF DUTY",
      nba: "NBA",
      mk: "MORTAL KOMBAT 11",
    },
    itemDescription: {
      fifa:
          'FIFA significa "Fédération Internationale de Football Association" y es la federación internacional que rige el fútbol de asociaciones (para distinguirlo del "fútbol sindical", es decir, el rugby).',
      cod: 'Un juego de disparos en primera persona, Call of Duty coloca al jugador al mando de un soldado de infantería que hace uso de varias armas de fuego auténticas de la Segunda Guerra Mundial en combate.',
      nba: 'La revolución analítica de la NBA (inserte el chiste de La venganza de los nerds aquí) ha cambiado la forma en que pensamos y hablamos sobre el baloncesto.',
      mk: '"Mortal Kombat." En juegos, MK se refiere a la franquicia de videojuegos "Mortal Kombat", desarrollada originalmente por Midway Games en 1992.',
    },
    /*Footer*/
    copyright: "© E Gamerz 2020. Todos los derechos reservados",
    // socials: {
    //   facebook: "Facebook",
    //   twitter: "Twitter",
    //   instagram: "Instagram",
    // },
  },
};
